class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.options = {
      cookieName: "languageSwitcherPopup",
      defaultLanguage: "en",
      active: "active",
      open: "language-switcher-open",
      form: ".shopify-localization-form",
      languageSwitcher: ".language-switcher",
      languageSwitcherOpenButton: ".language-switcher-open-button",
      languageSwitcherContent: ".language-switcher-content",
      languageSwitcherClose: ".language-switcher-close",
    };

    this.form = this.querySelector(this.options.form);
    this.languageSwitcherWrapper = this.querySelector(
      this.options.languageSwitcher,
    );
    this.languageSwitcherInput = this.querySelector(
      'input[name="locale_code"]',
    );
    this.countrySwitcherInput = this.querySelector(
      'input[name="country_code"]',
    );
    this.languageSwitcherOpenButton = this.querySelector(
      this.options.languageSwitcherOpenButton,
    );
    this.closeElements = this.querySelectorAll(
      this.options.languageSwitcherClose,
    );

    this.registerEvents();
  }

  registerEvents() {
    if (!!this.languageSwitcherOpenButton) {
      this.languageSwitcherOpenButton.addEventListener("click", () =>
        this.togglePanel(true),
      );
    }

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", (event) => this.onItemClick(event)),
    );

    if (!!this.closeElements) {
      this.closeElements.forEach((item) =>
        item.addEventListener("click", () => this.togglePanel(false)),
      );
    }
  }

  onItemClick(event) {
    event.preventDefault();
    const newCountryCode = event.currentTarget.dataset.countryCode;
    const countryChanged = this.countrySwitcherInput.value !== newCountryCode;

    this.countrySwitcherInput.value = newCountryCode;
    this.languageSwitcherInput.value = event.currentTarget.dataset.localeCode;
    const return_to = this.querySelector('[name="return_to"]');

    if(return_to)
    return_to.value=window.location.pathname;

    this.setCookieItem(
      this.options.cookieName,
      this.languageSwitcherInput.value.split("-")[0],
      30,
    );

    // Only clear the Click & Collect store selection when the market itself
    // changes — a previously selected store is no longer valid in a
    // different country. A pure language switch within the same market must
    // not reset it, otherwise the customer is prompted to pick a store again.
    if (countryChanged) {
      localStorage.removeItem('zippy-cc-store-selector-state');
      localStorage.removeItem('filter.p.m.custom.in_stock_locations');
    }

    const url = new URL(window.location.href);
    url.search = ''; 
    window.history.replaceState({}, '', url);

    if (this.form)  this.form.submit();
  }

  togglePanel(state) {
    this.languageSwitcherWrapper.classList[state ? "add" : "remove"](
      this.options.open,
    );
  }

  setCookieItem(key, value, expirationDays) {
    if (typeof key === "undefined" || key === null) {
      throw new Error("You must specify a key to set a cookie");
    }

    const date = new Date();
    date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);

    let secure = "";
    if (location.protocol === "https:") {
      secure = "secure";
    }

    document.cookie = `${key}=${value};expires=${date.toUTCString()};path=/;sameSite=lax;${secure}`;
  }
}

customElements.define("localization-form", LocalizationForm);
